import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import FlashMessage, { FlashMessageProps } from './FlashMessage';

const renderFlashMessage = (
  componentProps: FlashMessageProps,
  parent: HTMLElement,
) => {
  const portalDiv = document.createElement('div');

  parent.insertBefore(portalDiv, parent.firstChild);

  ReactDOM.render(<FlashMessage {...componentProps} />, portalDiv);
};

export const useFlashMessage = (
  componentProps: {
    message?: string;
    type?: 'alert' | 'notice';
  },
  parent: HTMLElement,
  reloadKey: string,
) => {
  useEffect(() => {
    if (sessionStorage.getItem(reloadKey)) {
      sessionStorage.removeItem(reloadKey);
      renderFlashMessage(componentProps, parent);
    }
  }, []);

  const setFlashMessage = () => sessionStorage.setItem(reloadKey, 'true');

  return { setFlashMessage };
};

export default useFlashMessage;
